export default "__VITE_ASSET__5407185d__"